import React from 'react';
import { Link } from 'react-router-dom';

const Hero: React.FC = () => {
  return (
    <section className="relative h-screen w-full overflow-hidden flex items-center justify-center">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://fbaptclwziljpmozftiz.supabase.co/storage/v1/object/public/images/cover.avif"
          alt="Bath & Body Works Essentials"
          className="w-full h-full object-cover scale-105 animate-[slowZoom_20s_ease-in-out_infinite]"
        />
        <div className="absolute inset-0 bg-brand-black/20"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-brand-black/40 via-transparent to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 text-white">
        <span className="text-[10px] uppercase tracking-[0.6em] mb-6 block font-bold drop-shadow-md opacity-0 animate-[fadeInUp_1s_ease-out_forwards]">
          Welcome to R&C Essentials
        </span>

        <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl mb-10 leading-tight drop-shadow-lg opacity-0 animate-[fadeInUp_1s_ease-out_0.3s_forwards]">
          L'Art de <br />
          <span className="italic font-light">l'Essentiel</span>
        </h1>

        <p className="text-brand-offwhite/80 text-lg md:text-xl font-light mb-12 max-w-2xl mx-auto leading-relaxed opacity-0 animate-[fadeInUp_1s_ease-out_0.5s_forwards]">
          Découvrez une sélection exclusive de rituels sensoriels importés pour sublimer votre quotidien.
        </p>

        <div className="opacity-0 animate-[fadeInUp_1s_ease-out_0.7s_forwards]">
          <Link
            to="/shop"
            className="inline-block border border-white px-10 py-4 text-white text-[11px] uppercase tracking-[0.3em] font-medium hover:bg-white hover:text-brand-black transition-all duration-500 rounded-full"
          >
            Explorer la collection
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;
